import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { StageMap } from "./StageMap";

export const WILL_DO = [
  "Place a new host's email and reply to them as their concierge.",
  "Open each stage's gate when the evidence is there, the way a Reviewer/Admin does.",
  "Send an RFQ, build and deliver a package, and see the payment held until the event.",
];

/** Offered once, after a person's first sign-in on this browser. */
export function WelcomeDialog({ onStart, onLater }: { onStart: () => void; onLater: () => void }) {
  return (
    <Dialog open onOpenChange={(open) => !open && onLater()}>
      <DialogContent className="max-w-lg gap-5">
        <DialogHeader>
          <DialogTitle className="text-xl">Take one event from first email to archive</DialogTitle>
          <DialogDescription className="text-foreground/80 text-sm leading-relaxed">
            A practice wedding walks you through the console in about 10 minutes. You use the real
            screens and click the real buttons, but the data is made up and nothing is sent to
            anyone.
          </DialogDescription>
        </DialogHeader>

        <StageMap reached={null} />

        <ul className="space-y-2 text-sm">
          {WILL_DO.map((line) => (
            <li key={line} className="flex gap-2.5">
              <span aria-hidden className="bg-brand mt-[7px] size-1.5 shrink-0 rounded-full" />
              {line}
            </li>
          ))}
        </ul>

        <DialogFooter className="items-center gap-2 sm:justify-between">
          <p className="text-muted-foreground text-xs">
            Replay it any time from Help{" "}
            <kbd className="bg-muted rounded border px-1 font-mono text-[11px]">?</kbd>
          </p>
          <div className="flex gap-2">
            <Button variant="ghost" onClick={onLater}>
              Not now
            </Button>
            <Button onClick={onStart}>Start the tour</Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
